export default "__VITE_ASSET__BQR2$10H__"